import { PhotoSubjectType } from '@common/interfaces/photo'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'photo'

export const [UPDATE_PHOTO_REQUEST, UPDATE_PHOTO_SUCCESS, UPDATE_PHOTO_FAILURE] =
  createRequestTypes(prefix, 'UPDATE_PHOTO')

/**
 * Set any subject's profile photo — a user, client, entity, company or CRM person.
 *
 * One action for all of them, parameterized by subject type, replacing the per-domain upload
 * actions each page used to reach for (`updateClient` with a `files[profilePicture]` FormData,
 * `updateEntityInfo` with `files[]`, `updateBrand` with `files[brandLogo]`, `updateUser` with
 * `files[]` + `isAvatarDelete`).
 */
export const updatePhoto = createAction(
  (subjectType: PhotoSubjectType, id: string, file: File) => ({
    type: [UPDATE_PHOTO_REQUEST, UPDATE_PHOTO_SUCCESS, UPDATE_PHOTO_FAILURE],
    promise: (api: IApi) => api.photo.update(subjectType, id, file),
  }),
)

export const [DELETE_PHOTO_REQUEST, DELETE_PHOTO_SUCCESS, DELETE_PHOTO_FAILURE] =
  createRequestTypes(prefix, 'DELETE_PHOTO')

/** Clear any subject's photo, reverting it to initials (or its Logo.dev mark). */
export const deletePhoto = createAction((subjectType: PhotoSubjectType, id: string) => ({
  type: [DELETE_PHOTO_REQUEST, DELETE_PHOTO_SUCCESS, DELETE_PHOTO_FAILURE],
  promise: (api: IApi) => api.photo.delete(subjectType, id),
}))
